import { render, staticRenderFns } from "./BlockFlat.vue?vue&type=template&id=46db3b05&scoped=true&"
import script from "./BlockFlat.vue?vue&type=script&lang=js&"
export * from "./BlockFlat.vue?vue&type=script&lang=js&"
import style0 from "./BlockFlat.vue?vue&type=style&index=0&id=46db3b05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db3b05",
  null
  
)

export default component.exports